<!-- <app-modal #modalRoot [maximizable]="false" class="modal-demo" [inViewport]="false"> -->
<div class="dialog">
  <div class="dialog-title d-flex justify-content-between">
    <div class="d-flex align-items-center">
      <mat-icon>drag_indicator</mat-icon>
      <h6 class="mb-0">Agreements
      </h6>
    </div>
    <img src="assets/svg/Multiply.svg" alt="close" (click)="closeDialog()">
  </div>
  <div class="content pt-0 px-0">
    <div class="info">
      <div class="content">
        <h6>Enquiry</h6>
        <p>{{data.enquiry_id}}</p>
    </div>
      <div class="content">
        <h6>Customer</h6>
        <p>{{data?.customer}}</p>
      </div>
      <div class="content">
        <h6>Parts</h6>
        <p>{{data.total_parts}}</p>
      </div>
      <div class="content">
        <h6>Batches</h6>
        <p>{{data.total_batches}}</p>
      </div>
    </div>

    <form [formGroup]="agreementForm">
      <mat-tab-group animationDuration="10ms" disableRipple="true">
        <mat-tab *ngFor="let part of parts.controls; let pIndex = index" [formGroup]="part">
          <ng-template mat-tab-label>
            <div class="d-flex flex-column align-items-center">
              <mat-icon> folder </mat-icon>
              <span>{{getPartName(part)}}</span>
            </div>
          </ng-template>

          <mat-tab-group (selectedTabChange)="changeProjectTab($event.index)" animationDuration="10ms"
            [selectedIndex]="activeTab" disableRipple="true">
            <mat-tab *ngFor="let batch of part.get('batches').controls; let i = index" [formGroup]="batch">
              <ng-template mat-tab-label>
                <div class="d-flex flex-column align-items-center">
                  <mat-icon> layers</mat-icon>
                  <span>Batch {{i+1}}</span>
                </div>
              </ng-template>

              <table class="mat-table">
                <tr class="mat-header-row">
                  <th class="mat-header-cell">Item</th>
                  <th class="mat-header-cell">Customer Inputs</th>
                  <th class="mat-header-cell">Your Inputs</th>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Quantity</td>
                  <td class="mat-cell">{{batch?.customer_agreed_quantity}}</td>
                  <td class="mat-cell">
                    <mat-form-field class="form-full-width" appearance="outline">
                      <input type="number" class="border-0" matInput placeholder="Enter"
                        formControlName="agreed_quantity" (blur)="onBlur()" />
                    </mat-form-field>
                  </td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Unit Price</td>
                  <td class="mat-cell">{{batch?.customer_total_unit_cost | currency:currencySymbol}}</td>
                  <td class="mat-cell">
                    <mat-form-field class="form-full-width" appearance="outline">
                      <div class="d-flex align-items-end">
                        <span matPrefix>{{ currencySymbol }}&nbsp;</span>
                        <input class="border-0" matInput placeholder="Enter" formControlName="total_unit_cost"
                          (blur)="onBlur()" />
                      </div>

                    </mat-form-field>
                  </td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Total Price</td>
                  <td class="mat-cell">{{batch?.customer_agreed_quantity*batch?.customer_total_unit_cost |
                    currency:currencySymbol}}</td>
                  <td class="mat-cell">
                    <mat-form-field class="form-full-width" appearance="outline">
                      <div class="d-flex align-items-end">
                        <span matPrefix>{{ currencySymbol }}&nbsp;</span>
                        <input class="border-0" matInput placeholder="Enter" formControlName="total_price"
                          (blur)="onBlur()" />
                      </div>
                    </mat-form-field>
                  </td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Delivery Schedule</td>
                  <td class="mat-cell">{{batch?.customer_actual_date | date:'medium'}}</td>
                  <td class="mat-cell">
                    <mat-form-field class="form-full-width" appearance="outline">
                      <mat-label>Choose a date</mat-label>
                      <input class="border-0" matInput [matDatepicker]="picker1" formControlName="actual_date"
                        (blur)="onBlur()" />
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Payment Terms</td>
                  <td class="mat-cell">{{batch?.customer_payment_terms}}</td>
                  <td class="mat-cell">
                    <mat-form-field class="form-full-width" appearance="outline">
                      <input class="border-0" matInput placeholder="Enter" formControlName="payment_terms"
                        (blur)="onBlur()" />
                    </mat-form-field>
                  </td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Shipping Terms</td>
                  <td class="mat-cell">{{batch?.customer_shipping_terms}}</td>
                  <td class="mat-cell">
                    <mat-form-field class="form-full-width" appearance="outline">
                      <input class="border-0" matInput placeholder="Enter" formControlName="shipping_terms"
                        (blur)="onBlur()" />
                    </mat-form-field>
                  </td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Quality Standards</td>
                  <td class="mat-cell">{{batch?.customer_quality_standards}}</td>
                  <td class="mat-cell">
                    <mat-form-field class="form-full-width" appearance="outline">
                      <input class="border-0" matInput placeholder="Enter" formControlName="quality_standards"
                        (blur)="onBlur()" />
                    </mat-form-field>
                  </td>
                </tr>
                <tr class="mat-row">
                  <td class="mat-cell">Inspection and Acceptance</td>
                  <td class="mat-cell">
                    {{batch?.customer_inspection_and_acceptance}}
                  </td>
                  <td class="mat-cell">
                    <mat-form-field class="form-full-width" appearance="outline">
                      <input class="border-0" matInput placeholder="Enter" formControlName="inspection_and_acceptance"
                        (blur)="onBlur()" />
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
      </mat-tab-group>



    </form>
  </div>
  <div class="footer p-2">
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary mr-3 fw-semibold" (click)="closeDialog()">
        Cancel
      </button>
      <button [disabled]="!agreementForm.valid" class="btn btn-primary fw-semibold"
        (click)="signOffAgreement();closeDialog()">
        Sign Off
      </button>
    </div>
  </div>
</div>
<!-- </app-modal> -->